import Tooltip from "@material-ui/core/Tooltip";
import { envSettings } from "core/EnvSettings";
import React from "react";
import { useRecordContext, useTranslate } from "react-admin";

export const PalletIconField = ({ icon: Icon, tooltipKey, iconStyle, isVisible }) => {
	const record = useRecordContext();
	const translate = useTranslate();

	if (!envSettings.REACT_APP_FF_STORAGE_MODULE) return null;
	if (isVisible && !isVisible(record)) return null;

	return (
		<Tooltip title={translate(tooltipKey)}>
			<span>
				<Icon style={{ fontSize: 20, verticalAlign: "middle", ...iconStyle }} />
			</span>
		</Tooltip>
	);
};
